var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"w-full max-w-xs"},[_vm._v(" Listbox ")])}
var staticRenderFns = []

export { render, staticRenderFns }